
import React, { useEffect, useState } from "react";
import { Dropdown } from 'primereact/dropdown';
import './FilterImgDrop.scss'
import { getAuthor, Baseurl } from "../../../service/apiService";

const FilterImgDrop = (props) => {
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [author,setAuthor] = useState([])
    const [countries, setCountries] = useState([]);
      

const init = async () => {
  console.log(props,'ooo');
  
if(props.from === 'blog'){
 let result = await getAuthor()
 setAuthor(result.data.data)
  let data = result?.data.data.map((item) => ({name:item?.name, code: item?._id, img: item?.img}))
  setCountries(data)
}
if(props.from === 'editblog'){
 let result = await getAuthor()
 setAuthor(result.data.data)
  let data = result?.data.data.map((item) => ({name:item?.name, code: item?._id, img: item?.img}))
  setCountries(data)
  setSelectedCountry(props?.authorData)
  props.setupAuthor(props?.authorData)
}
}

const settingSelectedValue = (e) => {
setSelectedCountry(e.value)
props.setupAuthor(e.value)
}
  useEffect(() => {
  (async () => {
    await init()
  })()
  },[])  

    const selectedCountryTemplate = (option, props) => {
        if (option) {
            return (
                <div className="d-flex align-items-center">
                    <img alt={option.name} src={`${Baseurl}/view/imageupload/${option?.img}?t=${new Date().getTime()}`} className={`mr-2 flag flag-${option.code.toLowerCase()}`} style={{ width: '18px' }} />
                    <div>{option.name}</div>
                </div>
            );
        }

        return <span>{props.placeholder}</span>;
    };

    const countryOptionTemplate = (option) => {
        return (
            <div className="d-flex align-items-center">
                <img alt={option.name} src={`${Baseurl}/view/imageupload/${option?.img}?t=${new Date().getTime()}`} className={`mr-2 flag flag-${option.code.toLowerCase()}`} style={{ width: '18px' }} />
                <div>{option.name}</div>
            </div>
        );
    };

  return (
    <div>

<div className="card d-flex justify-content-center">
            <Dropdown value={selectedCountry} onChange={(e) => settingSelectedValue(e)} options={countries} optionLabel="name" placeholder="Select a Author" 
             filter valueTemplate={selectedCountryTemplate} itemTemplate={countryOptionTemplate} className="w-full" />
        </div>   
      
    </div>
  )
}

export default FilterImgDrop
        